import { render, staticRenderFns } from "./TutorRecommendations.vue?vue&type=template&id=b2106710&scoped=true"
import script from "./TutorRecommendations.vue?vue&type=script&lang=js"
export * from "./TutorRecommendations.vue?vue&type=script&lang=js"
import style0 from "./TutorRecommendations.vue?vue&type=style&index=0&id=b2106710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2106710",
  null
  
)

export default component.exports